// Shared preview library (Launch Media v1, SM-3): which viewer a file opens in. Any app that shows
// files uses this, so every app previews the same way. Types come from the server (picture, video…).
export type PreviewKind = "picture" | "pdf" | "video" | "audio" | "table" | "text" | "none";

const ext = (name: string) => (String(name).split("?")[0].split(".").pop() || "").toLowerCase();

export const previewKind = (type: string, name: string): PreviewKind => {
  if (type === "image") return "picture";
  if (type === "pdf") return "pdf";
  if (type === "video") return "video";
  if (type === "audio") return "audio";
  if (type === "sheet") return ["csv", "tsv"].includes(ext(name)) ? "table" : "none";
  if (type === "doc") return ["txt", "md"].includes(ext(name)) ? "text" : "none";
  return "none";
};
